<template>
  <div class="row">
    <div class="col-6">
      <draggable
        class="list-group"
        tag="ul"
        v-model="list"
        v-bind="dragOptions"
        @start="isDragging = true"
        @end="checkMove"
      >
        <transition-group type="transition" name="flip-list">
          <li
            class="list-group-item"
            v-for="(element, index) in list"
            :key="element.name"
          >
            <span v-if="editingIntakeIndex !== index">
              <i
                :class="
                  element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'
                "
                @click="element.fixed = !element.fixed"
                aria-hidden="true"
              ></i>
              {{ element.name }}

              <div>
                <b-icon
                  icon="pen"
                  type="is-danger"
                  size="is-small"
                  @click.native.prevent="editElement(element, index)"
                ></b-icon>
                <b-icon
                  icon="delete"
                  type="is-danger"
                  size="is-small"
                  class="ml-4 d-none"
                  @click.native.prevent="deleteIntake(element.id, index)"
                ></b-icon>
              </div>
            </span>

            <div v-else class="columns">
              <b-field class="column is-full larger-input">
                <b-input
                  v-model="editingIntake"
                  @keyup.native.enter="submitField"
                  type="text"
                  ref="editCellValue"
                ></b-input>
              </b-field>
              <div class="buttons column is-full d-flex justify-content-around">
                <b-icon
                  style="cursor: pointer"
                  @click.native.prevent="cancelSubmit()"
                  label="Cancel"
                  icon="cancel"
                  type="is-danger"
                ></b-icon>
                <b-icon
                  style="cursor: pointer; margin-left: 12px"
                  @click.native.prevent="submitField()"
                  label="Finish"
                  icon="check-circle-outline"
                  type="is-success"
                ></b-icon>
              </div>
            </div>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="col-3">
      <b-field label="Add new intake" class="column">
        <b-input
          v-model="newIntake"
          type="text"
          name="newIntake"
          @keyup.native.enter="addNewIntake()"
        ></b-input>
      </b-field>

      <b-field label="Select leaderboard active intake" class="column">
        <b-select v-model="intakeName" placeholder="Select an intake">
          <option
            v-for="option in list"
            :value="option.name"
            :key="option.name"
          >
            {{ option.name }}
          </option>
        </b-select>
      </b-field>

      <b-button @click="createNewCampaign()" type="is-success" class="ml-3"
        >Create Campaign</b-button
      >
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import StudentService from '../../services/student.service';
import LeaderboardService from '../../services/leaderboard.service';
import AdminService from '../../services/admin.service';
const message = [
  'September/October/November 2024',
  'January/February 2024',
  'April/May/June 2024',
  'January/February 2023',
  'April/May/June 2023',
  'September/October/November 2023',
  'January/February 2025',
  'April/May/June 2025',
];

export default {
  name: 'transition-example',
  display: 'Transition',
  order: 6,
  components: {
    draggable,
  },
  data() {
    return {
      list: message.map((name, index) => {
        return {
          name,
          order: index + 1,
        };
      }),
      intakeName: null,
      newIntake: '',
      editingIntakeIndex: -1,
      editingIntake: '',
    };
  },
  mounted() {
    this.checkForIntakes();
  },
  methods: {
    editElement(element, index) {
      this.editingIntake = element.name;
      this.editingIntakeIndex = index;
    },
    createNewCampaign() {
      if (!this.intakeName) {
        this.$buefy.toast.open({
          duration: 3000,
          message: 'Please select an intake',
          position: 'is-bottom',
          type: 'is-warning',
        });

        return;
      }

      LeaderboardService.createNewLeaderboardIntake({
        name: this.intakeName,
      }).then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message: 'Changed campaign active intake',
          position: 'is-bottom',
          type: 'is-success',
        });

        LeaderboardService.generateLeaderboard();
      });
    },
    submitField() {
      let data = this.list[this.editingIntakeIndex];
      data.name = this.editingIntake;
      AdminService.updateIntake([data]).then(() => {
        this.list[this.editingIntakeIndex] = data;
        this.cancelSubmit();
      });
    },
    addNewIntake() {
      if (!this.newIntake.length) {
        return;
      }

      const data = {
        order: this.list.length + 1,
        name: this.newIntake,
      };

      AdminService.addNewIntake(data).then((response) => {
        this.list.push(response.data);
      });
    },
    cancelSubmit() {
      this.editingIntake = '';
      this.editingIntakeIndex = -1;
    },
    checkMove(e) {
      const updatedOrder = this.list.map((intake, index) => {
        return {
          ...intake,
          order: index + 1,
        };
      });

      AdminService.updateIntake(updatedOrder);
    },
    deleteIntake(id, index) {
      AdminService.deleteIntake(id).then(() => {
        this.list.splice(index, 1);
      });
    },
    async checkForIntakes() {
      await StudentService.fetchIntakes().then((response) => {
        if (response.data && response.data.length) {
          const orderedData = response.data.sort(
            (a, b) => parseFloat(a.order) - parseFloat(b.order)
          );
          this.list = orderedData;
        } else {
          AdminService.initialIntakes(this.list).then(() => {
            this.checkForIntakes();
          });
        }
      });
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item > span {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list-group-item i {
  cursor: pointer;
}
</style>
